import { createFileRoute } from '@tanstack/react-router'

import PemetaanWilkerPage from '@/components/pages/monitoring/_pemetaan-wilker/containers/PemetaanWilkerPage'

export const Route = createFileRoute('/report/pemetaan-wilker/')({
  component: () => <PemetaanWilkerPage />
})
